module.exports = __webpack_public_path__ + "img/four-screen_content.e007138a.jpg";